// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__Ee3ds","green":"styles_green__q+7CZ","ghost":"styles_ghost__idnYw","warning":"styles_warning__DS156","gray":"styles_gray__hP5Oe"};